'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactYoutube = require('react-youtube');

var _reactYoutube2 = _interopRequireDefault(_reactYoutube);

var _Slide = require('./Slide');

var _index = require('../../../index');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SliderView: {
        displayName: 'SliderView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/CartProduct/Slider/default/SliderView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MAX_COUNT_BIG_SLIDER = 8;
var MAX_COUNT_SMAL_SLIDER = 5;

var SliderView = _wrapComponent('SliderView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(SliderView, _Component);

    function SliderView(props) {
        (0, _classCallCheck3.default)(this, SliderView);

        // вызовем родительский конструктор, чтобы ничего не сломалось
        var _this = (0, _possibleConstructorReturn3.default)(this, (SliderView.__proto__ || (0, _getPrototypeOf2.default)(SliderView)).call(this, props));

        _this.getVideoId = function (url) {
            if (url.includes('youtube')) {
                return url.substr(url.indexOf('=') + 1);
            } else if (url.includes('youtu.be')) {
                return url.split('/').reverse()[0];
            }
        };

        _this.state = {
            countForSendBasket: 1
        };
        return _this;
    }

    (0, _createClass3.default)(SliderView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                product_detail = _props.product_detail,
                clickOnActive = _props.clickOnActive,
                clickOnVideo = _props.clickOnVideo,
                full_screen_mode = _props.full_screen_mode,
                video_mode = _props.video_mode,
                start_index_preview = _props.start_index_preview,
                currency = _props.currency,
                lang = _props.lang,
                pictures = product_detail.pictures,
                withVideo = product_detail.url_video_review && product_detail.url_video_review.length > 0,
                video = withVideo ? _react3.default.createElement(
                'div',
                { className: 'descr-video', onClick: clickOnVideo },
                ' ',
                lang['store.common.video'],
                ' '
            ) : null;


            var active = void 0,
                result_active = void 0,
                preview = void 0,
                previews = void 0,
                old_price = void 0,
                price = 0,
                next = void 0,
                prev = void 0;
            var itr = 0,
                countPreview = 0;
            var imgSrc = '/assets/images/placeholder.png';

            // Приводим к типу int и округляем число до сотых
            if (product_detail.price) {
                price = parseInt(product_detail.price).toFixed(2);
            }

            if (pictures || video_mode) {
                var firstImg = product_detail.pictures[0] && product_detail.pictures[0].id || imgSrc;
                if (!video_mode || !full_screen_mode) {
                    active = pictures.map(function (item, i) {
                        // Устанавливаем активный слайд
                        if (item.id == _this2.props.active_slide) {
                            return _react3.default.createElement(_Slide.Slide, {
                                key: "Slide_active_" + i,
                                type: 'big',
                                src: item.url,
                                clickOnActive: clickOnActive,
                                firstImg: firstImg,
                                realImg: item.id });
                        }
                    });
                } else {

                    active = _react3.default.createElement(
                        'div',
                        { className: 'active-video' },
                        _react3.default.createElement(_reactYoutube2.default, {
                            videoId: this.getVideoId(product_detail.url_video_review),
                            onReady: function onReady(event) {
                                return event.target.pauseVideo();
                            }
                        })
                    );
                }

                if (!full_screen_mode && pictures) {
                    // для маленького слайдера
                    if (pictures.length > 1) {
                        result_active = _react3.default.createElement(
                            'div',
                            { id: 'owl-single-product' },
                            _react3.default.createElement(
                                'div',
                                { className: 'prev', onClick: function onClick() {
                                        _this2.props.clickOnPrev(countPreview);
                                    } },
                                _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: '' })
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'single-product-gallery-item not_full_slider', id: 'slide1' },
                                active
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'next', onClick: function onClick() {
                                        _this2.props.clickOnNext(countPreview);
                                    } },
                                _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: '' })
                            )
                        );
                    } else if (pictures.length === 1) {
                        result_active = _react3.default.createElement(
                            'div',
                            { id: 'owl-single-product' },
                            _react3.default.createElement(
                                'div',
                                { className: 'single-product-gallery-item not_full_slider', id: 'slide1' },
                                active
                            )
                        );
                    } else if (pictures.length === 0) {
                        result_active = _react3.default.createElement(
                            'div',
                            { id: 'owl-single-product' },
                            _react3.default.createElement(
                                'div',
                                { className: 'single-product-gallery-item not_full_slider', id: 'slide1' },
                                _react3.default.createElement(_Slide.Slide, {
                                    type: 'big',
                                    src: imgSrc,
                                    clickOnActive: function clickOnActive() {}
                                })
                            )
                        );
                    }
                }

                preview = pictures.map(function (item, i) {

                    if (i >= start_index_preview) {
                        if (!full_screen_mode) {
                            countPreview = MAX_COUNT_SMAL_SLIDER; // для неполноэкранного режима отображаем 5 превьюх
                        } else {
                            countPreview = MAX_COUNT_BIG_SLIDER; // для полноэкранного режима отображаем 8 превьюх
                        }
                        if (withVideo) {
                            countPreview--;
                        }

                        if (itr < countPreview) {
                            ++itr;
                            return _react3.default.createElement(_Slide.Slide, {
                                key: "Slide_" + i,
                                active: item.id == _this2.props.active_slide,
                                type: 'small',
                                id: item.id,
                                src: item.preview_url,
                                changeSlide: _this2.props.handleChangeSlide });
                        }
                    }
                });
            }

            if (preview.length > 1) {
                if (full_screen_mode) {
                    previews = _react3.default.createElement(
                        'div',
                        { className: 'slide-container' },
                        _react3.default.createElement(
                            'div',
                            { className: 'center ' + (withVideo ? 'with-video' : '') },
                            _react3.default.createElement(
                                'div',
                                { className: 'small-prev', onClick: this.props.clickOnPrevPreview },
                                _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: '' })
                            ),
                            preview,
                            _react3.default.createElement(
                                'div',
                                { className: 'small-next', onClick: function onClick() {
                                        _this2.props.clickOnNextPreview(countPreview);
                                    } },
                                _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: '' })
                            )
                        ),
                        video
                    );
                } else {
                    previews = _react3.default.createElement(
                        'div',
                        { className: 'slide-container' },
                        _react3.default.createElement(
                            'div',
                            { className: 'center ' + (withVideo ? 'with-video' : '') },
                            _react3.default.createElement(
                                'div',
                                { className: 'small-prev', onClick: this.props.clickOnPrevPreview },
                                _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: '' })
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'single-product-gallery-thumbs gallery-thumbs' },
                                _react3.default.createElement(
                                    'div',
                                    { id: 'owl-single-product-thumbnails' },
                                    preview
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'small-next', onClick: function onClick() {
                                        _this2.props.clickOnNextPreview(countPreview);
                                    } },
                                _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: '' })
                            )
                        ),
                        video
                    );
                }
            } else if (preview.length == 1 && full_screen_mode && withVideo) {
                previews = _react3.default.createElement(
                    'div',
                    { className: 'slide-container' },
                    _react3.default.createElement(
                        'div',
                        { className: 'center with-video' },
                        _react3.default.createElement(
                            'div',
                            { className: 'single-product-gallery-thumbs gallery-thumbs' },
                            _react3.default.createElement(
                                'div',
                                { id: 'owl-single-product-thumbnails' },
                                preview
                            )
                        )
                    ),
                    video
                );
            } else if (withVideo) {
                previews = _react3.default.createElement(
                    'div',
                    { className: 'slide-container' },
                    _react3.default.createElement(
                        'div',
                        { className: 'center' },
                        video
                    )
                );
            }

            if (full_screen_mode) {
                // полноэкранный режим слайдера
                if (product_detail.old_price) {
                    old_price = _react3.default.createElement(
                        'div',
                        { className: 'price-prev' },
                        _react3.default.createElement(_components2.MoneyValue, {
                            value: product_detail.old_price,
                            icon: currency.icon,
                            iconAfterValue: currency.icon_after_value
                        })
                    );
                }

                if (pictures.length > 1 && !video_mode) {
                    prev = _react3.default.createElement(
                        'span',
                        { className: 'prev', onClick: function onClick() {
                                _this2.props.clickOnPrev(countPreview);
                            } },
                        _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: '' })
                    );

                    next = _react3.default.createElement(
                        'span',
                        { className: 'next', onClick: function onClick() {
                                _this2.props.clickOnNext(countPreview);
                            } },
                        _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: '' })
                    );
                }

                return _react3.default.createElement(
                    'div',
                    { className: 'text-center' },
                    prev,
                    _react3.default.createElement(
                        'div',
                        { className: 'product-item-holder size-big single-product-gallery small-gallery' },
                        _react3.default.createElement(
                            'div',
                            { id: 'owl-single-product', className: 'flying-to-cart-holder' },
                            _react3.default.createElement(
                                'div',
                                { className: 'single-product-gallery-item big', id: 'slide1' },
                                active
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'row bottom-active' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-sm-12 col-lg-6' },
                                    previews
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-sm-12 col-lg-6 counter' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'body-holder', id: 'active' },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'body' },
                                            _react3.default.createElement(
                                                'div',
                                                { className: 'prices' },
                                                _react3.default.createElement(
                                                    'div',
                                                    { className: 'price-current' },
                                                    _react3.default.createElement(_components2.MoneyValue, {
                                                        value: price,
                                                        icon: currency.icon,
                                                        iconAfterValue: currency.icon_after_value
                                                    })
                                                ),
                                                old_price
                                            ),
                                            _react3.default.createElement(
                                                'div',
                                                { className: 'qnt-holder' },
                                                _react3.default.createElement(_index.QuantityProduct, { value: this.state.countForSendBasket,
                                                    callback: function callback(newCount) {
                                                        _this2.setState({ countForSendBasket: newCount });
                                                    } }),
                                                _react3.default.createElement(_index.AddToBasket, { id: 'addto-cart', product: product_detail,
                                                    className: ['huge'],
                                                    count: this.state.countForSendBasket })
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    next,
                    _react3.default.createElement(
                        'span',
                        { className: 'close' },
                        _react3.default.createElement('i', { className: 'fa fa-times fa-6', onClick: clickOnActive, 'aria-hidden': 'true' })
                    )
                );
            } else {
                return _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-12 col-md-5 gallery-holder' },
                    _react3.default.createElement(
                        'div',
                        { className: 'product-item-holder size-big single-product-gallery small-gallery' },
                        result_active,
                        previews
                    )
                );
            }
        }
    }]);
    return SliderView;
}(_react2.Component), _class.propTypes = {
    currency: _react2.PropTypes.object,
    lang: _react2.PropTypes.object
}, _temp));

exports.default = SliderView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/Slider/default/SliderView.jsx
// module id = 1636
// module chunks = 0